jQuery(document).ready(function($){




$('.ten_per_outer_overlay,.ten_per_close').click(function(){
 $("body").removeClass('show-collection-popup');
});

$('.welcome_popup_close,.welcome_close_popup_cvf').click(function(){
 $("body").removeClass('show_welcome_popup');
});



  $(".mobile_close_drawer").click(function(){
  $(".mobile_drawer_search").addClass('hide_search_bar_mobi');
});

  $(".mobile_drawer_search form button").click(function(e){
    e.preventDefault();
  $(".mobile_drawer_search").removeClass('hide_search_bar_mobi');
});
  

// file upload popup js //

   // liquid php code

  // Display selected file name
 $('#fileInput').on('change', function () {
  const file = this.files[0];
  if (file && file.type.startsWith('image/')) {
    const reader = new FileReader();
    reader.onload = function (e) {
      $('#imagePreview').attr('src', e.target.result);
    };
    reader.readAsDataURL(file);
  } else {
    $('#imagePreview').attr('src', '//kinderblast.com/cdn/shop/files/file_upload_img.jpg?v=11053875577359931862');
  }
});


  // Handle form submission
  $('#frmContact').submit(function (e) {
  e.preventDefault();

  const file = $('#fileInput')[0].files[0];
  const email = $('#userEmail').val();
  const resultBox = $('#get_popup_results');

  if (!file || !email) {
    resultBox.html('<p style="color: red;">❌ Please provide both email and file.</p>');
    return;
  }

 // Show loader in button
  $('#uploadBtn .btn-text').hide();
  $('#uploadBtn .btn-loader').show();
    
  const formData = new FormData();
  formData.append("file", file);
  formData.append("email", email);

  $.ajax({
    url: "https://lemonchiffon-anteater-374319.hostingersite.com/default.php", // your server URL
    type: "POST",
    data: formData,
    contentType: false,
    processData: false,
    success: function (response) {
      console.log("✅ Success: " + response);
      // $('#frmContact')[0].reset();
      // $('#fileNameDisplay').text('');

$('.popup_featbox_wrapper').addClass('success_message_box_cst_fp');
      
     // Replace form content with success message
  $('#popupResultContent').html(`
    <div class="success-message" style="text-align: center;">
      <h2 style="color:#FF007A; font-size:2em; font-weight:800;">GOT IT!</h2>
      <div style="width:80px; height:4px; background:#00b5f5; margin: 0 auto 20px;"></div>
      <p style="font-size:1.2em;">THANK YOU FOR SHARING THAT SNAPSHOT.</p>
      <img src="https://cdn-icons-png.flaticon.com/512/3609/3609368.png" alt="camera" style="width:60px; margin:15px auto;">
      <p style="background: #ffe3ec; padding:10px; border-radius:8px; margin-top: 15px;">
        We’ve sent a promo code to your inbox
      </p>
    </div>
  `);
    },
    error: function (xhr, status, error) {
       $('#uploadBtn .btn-text').show();
      $('#uploadBtn .btn-loader').hide();
      console.log("❌ Error: " + error + "\n" + xhr.responseText);
      resultBox.html(`<p style="color: red;">❌ Failed to upload. Please try again.</p>`);
    }
  });
});




  // liquid php code

var file_upload_popup = true;
      jQuery(".get_featured_file_popup").click(function () {
        jQuery('body').addClass('trigger_file_upload');
        file_upload_popup = false;
      });

      jQuery(".popup_featbox_wrapper").click(function() {
        file_upload_popup = false;
      });

      jQuery("html,.popup_featbox_close").click(function () {
        if (file_upload_popup) {
          jQuery('body').removeClass('trigger_file_upload');
        }
        file_upload_popup = true;
      });
  
// file upload popup js //

jQuery('.print-vector-img a').click(function(){

jQuery('body').addClass('trigger_free_fun_popup');

});

jQuery('.free_fun_popup_close,.free_fun_overlay ').click(function(){

jQuery('body').removeClass('trigger_free_fun_popup');

});


var url = jQuery('.print-vector-img').attr('data-pdf');
var fileName = url ? url.split('/').pop().split('?')[0] : '';


console.log('page url ---->>',url);
console.log('fileName ->',fileName);
 function DownloadFile(fileName) {
            //Set the File URL.
          


            //Create XMLHTTP Request.
            var req = new XMLHttpRequest();
            req.open("GET", url, true);
            req.responseType = "blob";
            req.onload = function () {
                //Convert the Byte Data to BLOB object.
                var blob = new Blob([req.response], { type: "application/octetstream" });

                //Check the Browser type and download the File.
                var isIE = false || !!document.documentMode;
                if (isIE) {
                    window.navigator.msSaveBlob(blob, fileName);
                } else {
                    var url = window.URL || window.webkitURL;
                    link = url.createObjectURL(blob);
                    var a = document.createElement("a");
                    a.setAttribute("download", fileName);
                    a.setAttribute("href", link);
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                }
            };
            req.send();
 $('.free_fun_popup_box form').removeClass('FP_LOADER');
        };

  $('.free_fun_popup_box form').submit(function(e) {
  var $this = $(this);
$(this).addClass('FP_LOADER');
  $.ajax({
      type: "GET", // GET & url for json slightly different
      url: "https://kinderblast.us20.list-manage.com/subscribe/post-json?u=19b860e26464134654b5c7087&amp;id=c5f7cd1d2b&c=?",
      data: $this.serialize(),
      dataType    : 'json',
      contentType: "application/json; charset=utf-8",
      error       : function(err) { alert("Could not connect to the registration server."); },
      success     : function(data) {
          if (data.result != "success") {
          $('.free_fun_popup_box form').removeClass('FP_LOADER');
          } else {

               DownloadFile(fileName);

          }
      }
  });
  return false;
});

  jQuery('.mobile_drawer_links .has_dropdown_menu').click(function(){
jQuery(this).addClass('mobile_inner_child');
});

  var mobile_menu = true;
  jQuery('.mobile_menu,.mobile_menu_trigger_js').click(function(){
jQuery('body').toggleClass('js_toogle_menu_drawer');
mobile_menu = false;
});

  jQuery(".mobile_drawer").click(function() {
        mobile_menu = false;
      });

jQuery("html").click(function () {
        if (mobile_menu) {
 jQuery('body').removeClass('js_toogle_menu_drawer');

        }
        mobile_menu = true;
      });

  jQuery('.custom_footer_blocks_col_padd h3').click(function(){
jQuery(this).parents('.custom_footer_blocks_col_padd').toggleClass('toggle_mobile_accordion');
jQuery('.custom_footer_blocks_col_padd').not(jQuery(this).parents('.custom_footer_blocks_col_padd')).removeClass('toggle_mobile_accordion');
});

// product page 

  jQuery('.row_data').click(function(){

jQuery(this).toggleClass('toggle_mobi_dropdown');
jQuery('.row_data').not(jQuery(this)).removeClass('toggle_mobi_dropdown');
    
});

var remove_tab = true;
  jQuery('.custom_tab_head a').click(function () {
    var data_clas = jQuery(this).attr('data-handle');
    jQuery('.custom_product_page').attr('data-tab','p_tab_'+data_clas);
 remove_tab = false;
});

   jQuery(".tab_data_box").click(function() {
        remove_tab = false;
      });

jQuery("html").click(function () {
        if (remove_tab) {
 jQuery('.custom_product_page').removeAttr('data-tab');

        }
        remove_tab = true;
      });

$('.custom_product_left_thumb').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,infinite:true,
  fade: true,
  asNavFor: '.custom_product_right_thumb'
});
$('.custom_product_right_thumb').slick({
  slidesToShow: 3,
  slidesToScroll: 1,infinite:false,
  asNavFor: '.custom_product_left_thumb',
 vertical:true,arrows:false,
  focusOnSelect: true
});
  
// product page

  // explore more section //

$('.custom_related_list .custom_collection_box_list').slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
arrows:true,dots:false, 
responsive: [
{
      breakpoint: 1180,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
 {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

// explore more section //

// adding class to right side menu
var remove_megamenu = true;
$(".has_dropdown_menu .first_child>li").click(function() {
    $('.hover_box_right').addClass('active-right-menu');
  remove_megamenu = false;
});

// adding class to right side menu

   /*scrolling and revel boxes 
var mousewheel_love = 0;
 $('.box_love_icons_content').bind('mousewheel', function(e){
console.log('mousewheen love icons',e.originalEvent.wheelDelta /120 > 0);
        if(e.originalEvent.wheelDelta /120 > 0) {
           mousewheel_love--;
if(mousewheel_love == 0){
            $('.box_love_icons_content').removeClass('love_icon_scroll_1');
$('.box_love_icons_content').removeClass('love_icon_scroll_2');
$('.box_love_icons_content').removeClass('love_icon_scroll_3');
setTimeout(function(){
$('.toggle_block').removeClass('up_click').addClass('down_click');
 $('.box_love_icons_content').removeClass('up_scroll');
 }, 1400);
}

if(mousewheel_love == 1){
            $('.box_love_icons_content').addClass('love_icon_scroll_1');
$('.box_love_icons_content').removeClass('love_icon_scroll_2');
$('.box_love_icons_content').removeClass('love_icon_scroll_3');

}
if(mousewheel_love == 2){
            $('.box_love_icons_content').addClass('love_icon_scroll_2');
$('.box_love_icons_content').removeClass('love_icon_scroll_3');
$('.box_love_icons_content').removeClass('love_icon_scroll_1');

}
        }
        else{
mousewheel_love++;

if(mousewheel_love == 1){
            $('.box_love_icons_content').addClass('love_icon_scroll_1');
$('.box_love_icons_content').removeClass('love_icon_scroll_2');
$('.box_love_icons_content').removeClass('love_icon_scroll_3');

}
if(mousewheel_love == 2){
            $('.box_love_icons_content').addClass('love_icon_scroll_2');
$('.box_love_icons_content').removeClass('love_icon_scroll_1');
$('.box_love_icons_content').removeClass('love_icon_scroll_3');

}
if(mousewheel_love == 3){
            $('.box_love_icons_content').addClass('love_icon_scroll_3');
$('.box_love_icons_content').removeClass('love_icon_scroll_2');
$('.box_love_icons_content').removeClass('love_icon_scroll_1');

setTimeout(function(){
$('.toggle_block').removeClass('down_click').addClass('up_click');
 $('.box_love_icons_content').addClass('up_scroll');
 }, 1400);
}


     
        }
    });
 $('.box_trust_right_content').bind('mousewheel', function(e){
        if(e.originalEvent.wheelDelta /120 > 0) {
            $('.box_trust_right_content').removeClass('custom_scroll_trust');
        }
        else{
           $('.box_trust_right_content').addClass('custom_scroll_trust');
        }
    });

  
  
// scroll and revel boxes*/
  

  // quick view js 

jQuery('.coll_quick_view > a').click(function(e){
e.preventDefault();
var vthis = jQuery(this);
jQuery('.quick_view_badge').html('');
jQuery('.custom_quick_view_inner').attr('data-badge','');
  var get_subhg = jQuery(vthis).parents('.custom_collection_box_list_iner').find('.coll_data p').html();
var star_badge = "";
var other_badge = jQuery(vthis).parents('.custom_collection_box_list_iner').find('.badge_text img').attr('class');
if(jQuery(vthis).parents('.custom_collection_box_list_iner').hasClass('custom_coll_sale_product')){
star_badge = jQuery(vthis).parents('.custom_collection_box_list_iner').find('.coll_star_badge').html();
}



console.log('star_badge ->',star_badge);

jQuery('.custom_quick_view').addClass('quick_view_loader');
var variant_items_html = "";
var data_handle = jQuery(vthis).attr('data-handle');

function destroyCarousel() {
  if ($('.main_list_images').hasClass('slick-initialized')) {
    $('.main_list_images').slick('destroy');
  }      

  if ($('.thumb_list_images').hasClass('slick-initialized')) {
    $('.thumb_list_images').slick('destroy');
  }
}

jQuery.ajax({
      type: 'GET', 
      url: '/products/'+data_handle+'.js',
      dataType: 'json', 
success: function(data) {
   console.log('data ->',data);
jQuery('.custom_view_details a').attr('href',data.url);
destroyCarousel();
var list_thumbnails = jQuery('.thumb_list_images');
var list_main_images = jQuery('.main_list_images');
list_thumbnails.html("");
list_main_images.html("");
jQuery('.bulk_price_variant').html("");
$.each( data.images, function( i, image ) {
//console.log('image ->',image);
       list_main_images.append('<li><img   src="'+image+'"></li>');
        list_thumbnails.append('<li><img   src="'+image+'"></li>');
      
    });

$.each( data.variants, function( i, variant ) {
       var isLastElement = data.variants.length - 1;
      console.log('isLastElement',isLastElement);
var var_title = variant.title.split('(');
console.log('var_title ->',var_title);
var first_var_title = var_title[0];
var second_var_title = var_title[1];
var variant_length = data.variants.length;
console.log('variant_length ->',variant_length);

var sale_quick_view = "";

if (variant.compare_at_price > variant.price){
sale_quick_view = "quick_view_sale";

}

var val_compare_price = "";

if ($.trim(variant.compare_at_price)){   
    val_compare_price = Shopify.formatMoney(variant.compare_at_price);
}
console.log('val_compare_price ->',val_compare_price);

if (typeof second_var_title === "undefined") {
    second_var_title == '';
}
else{
second_var_title = second_var_title.replace(')','');
}

console.log('second_var_title ->',second_var_title);
var var_id = variant.id;
var var_price = Shopify.formatMoney(variant.price);

console.log('var_price',var_price);
var prod_tags = data.tags;
var bundle_price_val = "";
var var_active_cls = '';
if (i == isLastElement ){
var_active_cls = 'bulk_price_variant_col_active';
}
$.each( prod_tags, function( i, tag ) {
if(tag.indexOf('bundle_') != -1){
    bundle_price_val = tag.replace('bundle_','');
}
});
console.log('bundle_price_val',bundle_price_val);

       var each_price = variant.price / bundle_price_val;
console.log('each_price',each_price);
var each_price_money = Shopify.formatMoney(each_price);

variant_items_html = '<div class="bulk_price_variant_col '+sale_quick_view+'"><div class="bulk_price_variant_col_padd"><div class="bulk_price_variant_head"><p>'+var_title[0]+'</p><span>'+second_var_title+'</span></div><div class="bulk_price_variant_body"><div class="bulk_price_variant_price"><p class="js_comp_price">'+val_compare_price+'</p><p>'+var_price+'</p><p>(only '+each_price_money+' each)</p></div><div class="bulk_price_variant_qty"><div class="bulk_price_variant_qty_btn"><span data-field="quantity" class="bpvq_down"></span><input name="quantity" readonly type="text" value="1" /><span data-field="quantity" class="bpvq_up"></span></div></div><div class="bulk_price_variant_btn"><a data-id='+variant.id+' data-comp="'+val_compare_price+'" class="direct_add_to_cart" href="">ADD TO CART</a></div></div></div></div>';
  
jQuery('.bulk_price_variant').append(variant_items_html);

if (variant_length == 1){
jQuery('.bulk_price_variant').append('<div class="bulk_price_variant_col bulk_price_variant_not_avail_col"><div class="bulk_price_variant_col_padd"><div class="bulk_price_variant_head"><p>Single Pack</p><span>undefined</span></div><div class="bulk_price_variant_body"><div class="bulk_price_variant_price"><p>Option<br>Unavailable</p></div><div class="bulk_price_variant_qty"><div class="bulk_price_variant_qty_btn"><span data-field="quantity" class="bpvq_down"></span><input name="quantity" type="text" value="1"><span data-field="quantity" class="bpvq_up"></span></div></div><div class="bulk_price_variant_btn"><a href="">ADD TO CART</a></div></div></div></div>');
jQuery('.bulk_price_variant').addClass('single_varaint_only');
}
else{
jQuery('.bulk_price_variant').removeClass('single_varaint_only');
}

  });


jQuery('.quick_view_badge').html(star_badge);
jQuery('.custom_quick_view_inner').attr('data-badge',other_badge);
jQuery('.custom_quick_view_box_right h2').html(data.title);
  jQuery('.custom_quick_view_box_right_padd > h4').html(get_subhg);

    }

});

setTimeout(function(){
 $('.main_list_images').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  fade: true,
  asNavFor: '.thumb_list_images'
});
$('.thumb_list_images').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  asNavFor: '.main_list_images',
 vertical:true,arrows:false,
  focusOnSelect: true
});
jQuery('.custom_quick_view').removeClass('quick_view_loader');

}, 2000);
jQuery('body').addClass('activate_quick_view');
});


jQuery('.close_quick_view,.qucik_view_overlay').click(function(e){
jQuery('body').removeClass('activate_quick_view');
});

// quick view js 

$(document).on('click', '.bulk_price_variant_col', function(){
$(this).addClass('bulk_price_variant_col_active').siblings().removeClass('bulk_price_variant_col_active');
});

var love_icon_count=0;

// $(document).on('click', '.down_click', function(e){
//         e.preventDefault();
//         console.log('down_click before',love_icon_count);
// love_icon_count++;
// console.log('down_click after',love_icon_count);
// if(love_icon_count == 1){
//             $('.box_love_icons_content').addClass('love_icon_scroll_1');
// $('.box_love_icons_content').removeClass('love_icon_scroll_2');
// $('.box_love_icons_content').removeClass('love_icon_scroll_3');

// }
// if(love_icon_count == 2){
//             $('.box_love_icons_content').addClass('love_icon_scroll_2');
// $('.box_love_icons_content').removeClass('love_icon_scroll_1');
// $('.box_love_icons_content').removeClass('love_icon_scroll_3');

// }
// if(love_icon_count == 3){
//             $('.box_love_icons_content').addClass('love_icon_scroll_3');
// $('.box_love_icons_content').removeClass('love_icon_scroll_2');
// $('.box_love_icons_content').removeClass('love_icon_scroll_1');

// setTimeout(function(){
// $('.toggle_block').removeClass('down_click').addClass('up_click');
//  $('.box_love_icons_content').addClass('up_scroll');
//  }, 1400);
// }
//     });

// $(document).on('click', '.up_click', function(e){

//         e.preventDefault();
//         console.log('up_click',love_icon_count);

// love_icon_count--;

// if(love_icon_count == 0){
//             $('.box_love_icons_content').removeClass('love_icon_scroll_1');
// $('.box_love_icons_content').removeClass('love_icon_scroll_2');
// $('.box_love_icons_content').removeClass('love_icon_scroll_3');
// setTimeout(function(){
// $('.toggle_block').removeClass('up_click').addClass('down_click');
//  $('.box_love_icons_content').removeClass('up_scroll');
//  }, 1400);
// }

// if(love_icon_count == 1){
//             $('.box_love_icons_content').addClass('love_icon_scroll_1');
// $('.box_love_icons_content').removeClass('love_icon_scroll_2');
// $('.box_love_icons_content').removeClass('love_icon_scroll_3');

// }
// if(love_icon_count == 2){
//             $('.box_love_icons_content').addClass('love_icon_scroll_2');
// $('.box_love_icons_content').removeClass('love_icon_scroll_3');
// $('.box_love_icons_content').removeClass('love_icon_scroll_1');

// }


//     });

  // $('.trust_toggle').click(function(e) {
  //       e.preventDefault();
  //       console.log('clik');

  //           $('.box_trust_right_content').toggleClass('custom_scroll_trust');
  //   });

// inc decr plus minus

var buttonPlus = $(".bpvq_up");
var buttonMinus = $(".bpvq_down");

var incrementPlus = $(document).on('click', '.bpvq_up', function(){ 
console.log('upwards ->');
  var $n = $(this).parent(".bulk_price_variant_qty_btn").find("input");
  $n.val(Number($n.val()) + 1);
});

var incrementMinus = $(document).on('click', '.bpvq_down', function(){
console.log('downwards ->');
 var $n = $(this).parent(".bulk_price_variant_qty_btn").find("input");
  var amount = Number($n.val());
  if (amount > 1) {
    $n.val(amount - 1);
  }
});
 
// inc dec plus minus  
  

var removeClass = true;
var searchClass = true;

// scroll to top 

$(window).scroll(function() {
        if($(this).scrollTop() > 1000) {
            $('.scroll_to_top').show();
        }
        else {
             $('.scroll_to_top').hide();
        }
    });

$("a[href='#top']").click(function (e) {
e.preventDefault();
  $('html, body').animate({ scrollTop: 0 }, 'slow');
});
  
// scroll to top


  
 jQuery(".hover_box_parent,.custom_quick_view_box").click(function() {
        removeClass = false;
      });

   jQuery(".custom_search_form").click(function() {
        searchClass = false;
      });

jQuery("html").click(function () {
        if (removeClass) {
jQuery('body').removeClass('shop_to_stock_menu');

        }
        removeClass = true;
      });

jQuery("html").click(function () {
        if (searchClass) {
jQuery('body').removeClass('toggle_search_fx');

        }
        searchClass = true;
      });
  
  $(".custom_header_menu>ul>li:nth-child(2)>a").click(function(e) {
    e.preventDefault();
    $('html, body').animate({
        scrollTop: $(".Bulk_pricing").offset().top-250
    }, 2000);
});

$(window).scroll(function(){
  var sticky = $('.sticky_header'),
      scroll = $(window).scrollTop();

  if (scroll >= 500) sticky.addClass('HeaderFixed');
  else sticky.removeClass('HeaderFixed');
});

 jQuery('.bulk_price_arrow a,.box_count_icons_left_content a, .box_trust_left_content a,.mega_menu_triggrr,.has_dropdown_menu > a').click(function(e){
e.preventDefault();
 
jQuery('body').addClass('shop_to_stock_menu');
   jQuery('body').removeClass('trigger_free_fun_popup');
 removeClass = false;
});

  jQuery('.custom_header_nav_link_search').click(function(e){
e.preventDefault();
jQuery('body').addClass('toggle_search_fx');
   searchClass = false;
});

  


  jQuery('.first_child > li').click(function(){
jQuery(this).addClass('nav_active_menu').siblings().removeClass('nav_active_menu');
var data_menu = jQuery(this).attr('data-title');
    jQuery('.hover_box_right ul').hide();
    jQuery('.hover_box_right ul[data-title="'+data_menu+'"]').show();
});

// number animation js

// inViewport jQuery plugin
$(function($, win) {
  $.fn.inViewport = function(cb) {
    return this.each(function(i,el){
      function visPx(){
        var H = $(this).height(),
            r = el.getBoundingClientRect(), t=r.top, b=r.bottom;
        return cb.call(el, Math.max(0, t>0? H-t : (b<H?b:H)));  
      } visPx();
      $(win).on("resize scroll", visPx);
    });
  };
}(jQuery, window));


jQuery(function($) { // DOM ready and $ in scope

  $(".fig-number").inViewport(function(px) { // Make use of the `px` argument!!!
    // if element entered V.port ( px>0 ) and
    // if prop initNumAnim flag is not yet set
    //  = Animate numbers
    if(px>0 && !this.initNumAnim) { 
      this.initNumAnim = true; // Set flag to true to prevent re-running the same animation
      $(this).prop('Counter',0).animate({
        Counter: $(this).text()
      }, {
        duration: 4000,
        step: function (now) {
          $(this).text(Math.ceil(now));
        }
      });         
    }
  });

});  
  
// number animation js



// cart drawer js //

var cart_items_html = "";
  function loadcart() {

jQuery('body').removeClass('cart_screen_view_step activate_quick_view trigger_free_fun_popup  ');

jQuery.ajax({
      type: 'GET', 
      url: '/cart.js',
      dataType: 'json',
success: function(cart_data) {
console.log('-------cart_data----------');
console.log(cart_data);
console.log('-------cart_data----------');
jQuery('.custom_header_nav_link_cart').attr('data-count',cart_data.item_count);

jQuery('.custom_cart_body_iner').html('');
 


jQuery.each(cart_data.items, function(index, item) {

var var_comp_price ="";
console.log('item properties',item.properties['Comp_price']);



cart_items_html ='<div class="custom_cart_row" data-id="'+item.key+'"><div class="custom_cart_row_inner"><div class="custom_cart_row_flex"><div class="custom_cart_row_img"><a href="'+item.url+'"><img src="'+item.image+'" /></a></div><div class="custom_cart_row_details"><h4><a href='+item.url+'><span class="cst_js_cart_title">'+item.product_title+' </span><span class="cst_js_var_title">'+item.variant_title+'</span></a></h4><p class="js_cst_subhg"><a href='+item.url+'></a></p><div class="custom_cart_row_price"><p class="js_cst_cart_price"><s style="color:#aaa">'+item.properties['Comp_price']+'</s>'+Shopify.formatMoney(item.price)+'</p><p class="js_cst_cart_remove">Remove</p></div><div class="custom_cart_qty"><div class="bulk_price_variant_qty"><div class="bulk_price_variant_qty_btn"><span>Qty</span><span class="bpvq_down custom_cart_qty_btn"></span><input readonly type="text" value='+item.quantity+'><span class="bpvq_up custom_cart_qty_btn"></span></div></div></div></div></div></div></div>';




jQuery('.custom_cart_body_iner').append(cart_items_html);
});
jQuery('.js_full_cart_price').html(Shopify.formatMoney(cart_data.total_price));
// free shipping bar cal //

var freeShipping = 100 * 100 ;
var  totalPrice = cart_data.total_price;
var shippingDifference = freeShipping - totalPrice ; 
var shippingDifferencePercentage = shippingDifference /  100 ;
var shippingProgress = totalPrice * 100 / freeShipping ;

var shippingCost = 0;
// shipping tiers
if (totalPrice <= 50 * 100) {
  shippingCost = 18 * 100;
} else if (totalPrice > 50 * 100 && totalPrice <= 100 * 100) {
  shippingCost = 15 * 100;
} else {
  shippingCost = 0;
}

jQuery('.js_cst_remain_amt').html(Shopify.formatMoney(shippingDifference));
jQuery('.custom_cart_shipping_bar').attr('style','--progress:'+shippingProgress+'%');

if (totalPrice >= freeShipping) {
jQuery('.pending_fs').hide();
jQuery('.congt_fs').show();
jQuery('.custom_cart_shipping_bar').attr('data-full','100');
  }
  else{
    jQuery('.custom_cart_shipping_bar').attr('data-full','0');
jQuery('.pending_fs').show();
jQuery('.congt_fs').hide();
  jQuery('.custom_cart_footer_inner .pending_fs').html(Shopify.formatMoney(shippingCost)).show();

}
  
// free shipping bar cal //



}
});

jQuery('.cart_body').addClass('finishing_loading');
}

/**** cart drawer ****/


// load cart drawr 
var cartDrawer = true;
// jQuery(document).on('click', '.custom_header_nav_link_cart', function(e){ 
//   e.preventDefault();
// jQuery('body').addClass('cart_drawer_active');
// cartDrawer = false;
// });

  jQuery(".custom_cart_box_inner").click(function() {
        cartDrawer = false;
      });


      jQuery("html,.custom_cart_close,.custom_cart_actions > a:last-child").click(function () {

        if (cartDrawer) {
      jQuery('body').removeClass('cart_drawer_active');
jQuery('body').removeClass('cart_screen_view_step');
        }
        cartDrawer = true;
      });



// add to cart //
jQuery(document).on('click', '.direct_add_to_cart', function(e){ 
e.preventDefault();
var dataform = jQuery(this);
jQuery(dataform).addClass('cart_loading');
var get_compare_price = jQuery(dataform).attr('data-comp');
var data_id = jQuery(dataform).attr('data-id');
var data_qty = jQuery(dataform).parents('.bulk_price_variant_box').find('.bulk_price_variant_col.quick_view_sale.bulk_price_variant_col_active .bulk_price_variant_qty_btn input').val();

jQuery.ajax({
      type: 'POST', 
      url: '/cart/add.js',
      dataType: 'json', 
   data: { quantity: data_qty, id: data_id, properties: {'Comp_price': get_compare_price} },
success: function(data, textStatus, xhr) {
loadcart();
jQuery('body').addClass('cart_drawer_active');

}
});

setTimeout(function(){ 
jQuery(dataform).removeClass('cart_loading');
}, 1500);
});

// add to cart //

// remove cart js //

jQuery(document).on('click', '.js_cst_cart_remove', function(e){ 
e.preventDefault();
jQuery(this).parents('.custom_cart_row').addClass('custom_cart_row_loader_active');
var data_id= jQuery(this).parents('.custom_cart_row').data('id');



jQuery.ajax({
      type: 'POST', 
      url: '/cart/change.js',
      dataType: 'json', 
      data: { quantity: 0, id: data_id },
success: function(data) {
       
loadcart();

    }

});

});

// remove cart js //

// incrementdecrement 

     jQuery(document).on('click', '.custom_cart_qty_btn', function(e){
e.preventDefault();

jQuery(this).parents('.custom_cart_row').addClass('custom_cart_row_loader_active');

var cuure = jQuery(this);
var varaint_id = jQuery(this).parents('.custom_cart_row').data('id');
var counte_qua = jQuery(this).parents('.custom_cart_row').find('.custom_cart_qty .bulk_price_variant_qty_btn input').val();

       if (counte_qua > 0){
jQuery.ajax({
      type: 'POST', 
      url: '/cart/change.js',
      dataType: 'json', 
      data: { quantity: counte_qua, id: varaint_id },
success: function(data) {

loadcart();





}
});
       }
       else {


jQuery.ajax({
      type: 'POST', 
      url: '/cart/change.js',
      dataType: 'json', 
      data: { quantity: 0, id: varaint_id },
success: function(data) {
       



loadcart();

    }

});


}



});

// incrmentdecrement


// collection page add to cart //
jQuery(document).on('click', '.Indirect_add_to_cart', function(e){ 
e.preventDefault();
jQuery('body').addClass('cart_drawer_active cart_screen_view_step');
jQuery('body').removeClass('trigger_free_fun_popup ');
var vthis = jQuery(this);
var data_handle = jQuery(vthis).attr('data-handle');
var data_subhandle = jQuery(vthis).parents('.custom_collection_box_list_iner_padd').find('.coll_data p').html();

  jQuery.ajax({
      type: 'GET', 
      url: '/products/'+data_handle+'.js',
      dataType: 'json', 
success: function(data) {
   console.log('data ->',data);

jQuery('.cart_screen_view_collection_body .bulk_price_variant').html("");
jQuery('.cart_screen_view_collection_header img').attr('src',data.featured_image);

$.each( data.variants, function( i, variant ) {
       var isLastElement = data.variants.length - 1;
      console.log('isLastElement',isLastElement);
var var_title = variant.title.split('(');
console.log('var_title ->',var_title);
var first_var_title = var_title[0];
var second_var_title = var_title[1];
var variant_length = data.variants.length;
console.log('variant_length ->',variant_length);

var sale_quick_view = "";

if (variant.compare_at_price > variant.price){
sale_quick_view = "quick_view_sale";

}

var val_compare_price = "";

if ($.trim(variant.compare_at_price)){   
    val_compare_price = Shopify.formatMoney(variant.compare_at_price);
}
console.log('val_compare_price ->',val_compare_price);

if (typeof second_var_title === "undefined") {
    second_var_title == '';
}
else{
second_var_title = second_var_title.replace(')','');
}

console.log('second_var_title ->',second_var_title);
var var_id = variant.id;
var var_price = Shopify.formatMoney(variant.price);

console.log('var_price',var_price);
var prod_tags = data.tags;
var bundle_price_val = "";
var var_active_cls = '';
if (i == isLastElement ){
var_active_cls = 'bulk_price_variant_col_active';
}
$.each( prod_tags, function( i, tag ) {
if(tag.indexOf('bundle_') != -1){
    bundle_price_val = tag.replace('bundle_','');
}
});
console.log('bundle_price_val',bundle_price_val);

       var each_price = variant.price / bundle_price_val;
console.log('each_price',each_price);
var each_price_money = Shopify.formatMoney(each_price);

variant_items_html = '<div class="bulk_price_variant_col '+sale_quick_view+'"><div class="bulk_price_variant_col_padd"><div class="bulk_price_variant_head"><p>'+var_title[0]+'</p><span>'+second_var_title+'</span></div><div class="bulk_price_variant_body"><div class="bulk_price_variant_price"><p class="js_comp_price">'+val_compare_price+'</p><p>'+var_price+'</p><p>(only '+each_price_money+' each)</p></div><div class="bulk_price_variant_qty"><div class="bulk_price_variant_qty_btn"><span data-field="quantity" class="bpvq_down"></span><input name="quantity" readonly type="text" value="1" /><span data-field="quantity" class="bpvq_up"></span></div></div><div class="bulk_price_variant_btn"><a data-id='+variant.id+' data-comp="'+val_compare_price+'" class="direct_add_to_cart" href="">ADD TO CART</a></div></div></div></div>';
  
jQuery('.cart_screen_view_collection_body .bulk_price_variant').append(variant_items_html);

if (variant_length == 1){
jQuery('.cart_screen_view_collection_body .bulk_price_variant').append('<div class="bulk_price_variant_col bulk_price_variant_not_avail_col"><div class="bulk_price_variant_col_padd"><div class="bulk_price_variant_head"><p>Single Pack</p><span>undefined</span></div><div class="bulk_price_variant_body"><div class="bulk_price_variant_price"><p>Option<br>Unavailable</p></div><div class="bulk_price_variant_qty"><div class="bulk_price_variant_qty_btn"><span data-field="quantity" class="bpvq_down"></span><input name="quantity" readonly type="text" value="1"><span data-field="quantity" class="bpvq_up"></span></div></div><div class="bulk_price_variant_btn"><a href="" >ADD TO CART</a></div></div></div></div>');
jQuery('.cart_screen_view_collection_body .bulk_price_variant').addClass('single_varaint_only');
}
else{
jQuery('.cart_screen_view_collection_body .bulk_price_variant').removeClass('single_varaint_only');
}

  });



jQuery('.get_title_js').html(data.title);
jQuery('.get_subtitle_js').html(data_subhandle);

    }

});

});

// collection page add to cart //  




// cart drawer js //


  // hover meag menu js 

document.querySelectorAll('.hover_box_parent .first_child li').forEach(item => {
  item.addEventListener('mouseenter', function () {
    const title = item.getAttribute('data-title');

    // Remove nav_active_menu from all items
    document.querySelectorAll('.hover_box_parent .first_child li').forEach(li => {
      li.classList.remove('nav_active_menu');
    });

    // Add nav_active_menu to current item
    item.classList.add('nav_active_menu');

    // Hide all right-side boxes and remove active class
    document.querySelectorAll('.hover_box_right .second_child').forEach(box => {
      box.style.display = 'none';
      box.parentElement.classList.remove('active-right-menu');
    });

    // Show and activate matching box
    const matchingBox = document.querySelector(`.hover_box_right .second_child[data-title="${title}"]`);
    if (matchingBox) {
      matchingBox.style.display = 'block';
      matchingBox.parentElement.classList.add('active-right-menu');
    }
  });
});

  
  // hover mega menu js

// cart page adding subhg to packaging templte 


// cart page adding subhg to packaging templte 
 


});